import { render, staticRenderFns } from "./AgeInfor.vue?vue&type=template&id=539290be"
import script from "./AgeInfor.vue?vue&type=script&lang=js"
export * from "./AgeInfor.vue?vue&type=script&lang=js"
import style0 from "./AgeInfor.vue?vue&type=style&index=0&id=539290be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_wb3t4kok4nbmrmr53k32ebcn2u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports